export default "__VITE_ASSET__CdSvMpVK__"